import { cn } from '@/platform/lib/utils';

const NavigationSeparator = ({ className }) => (
    <div
        aria-hidden='true'
        className={cn(
            'flex w-2.5 shrink-0 items-stretch self-stretch overflow-hidden',
            className
        )}
    >
        <div className='w-px bg-gray-200 shadow-[0_0_8px_rgba(0,0,0,0.5)]' />
    </div>
);

export default NavigationSeparator;
